module.exports = {
  adsetPublicUrl: 'https://adset.apester.com',
  analyticsBaseUrl: 'https://analytics.apester.com',
  authBaseUrl: 'https://auth.apester.com',
  campaignBaseUrl: 'https://campaign.apester.com',
  campaignApiPublicUrl: 'https://campaign-api.apester.com',
  adsetApiPublicUrl: 'https://adset-api.apester.com',
  consoleBaseUrl: 'https://console.apester.com',
  vreminiUrl: 'https://vremini.apester.com',
  editorBaseUrl: 'https://app.apester.com',
  eventsPublicUrl: 'https://events.apester.com',
  imagesNewUrl: 'https://img.apester.com',
  imagesUrl: 'https://img.apester.com',
  interactionBaseUrl: 'https://interaction.apester.com',
  jobsUrl: 'https://jobs-api.apester.com',
  paymentsUrl: 'https://payments.apester.com/',
  planApiUrl: 'https://plans-api.apester.com',
  playerBaseUrl: 'https://renderer.apester.com/v2/',
  portalUrl: 'https://portal.apester.com',
  staticBucket: 'https://static.apester.com/',
  stripePK: 'pk_live_YL6LSULaHEGhq0GpzvPoulFe00SJvfnPkA',
  usersBaseUrl: 'https://users.apester.com',
  wixIntegrationUrl: '___WIX_INTEGRATION_PUBLIC_URL___',
  webhooksBaseUrl: 'https://webhooks.apester.com',
  release: '2.5.66',
};
